import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'Douleutaras/redux/hooks';
import { getSellerReviews, selectPinnedSellerReview, singleSellerReviewsEndpoint } from 'Douleutaras/redux/data/seller/sellerReviewsSlice';
import NumberedPagination from 'Douleutaras/components/Pagination/NumberedPagination';
import { GetServerSideProps } from 'Douleutaras/types/ssr';

export const getServerSideProps: GetServerSideProps = async ({ store, params }) => {
  if (!params.username) { return; }
  await Promise.all([
    store.dispatch(getSellerReviews({ username: params.username, page: 1 })),
    store.dispatch(getSellerReviews({ username: params.username, page: 1, isPinned: true }))
  ]);
};

import './ReviewSection.scss';
import { ReviewSummary } from './ReviewSummary';
import { ReviewCard } from './ReviewCard';

const DEFAULT_STARTING_PAGE_NUMBER  = 1; // Always start from page 1

export const ReviewSection = ({ username }) => {
  const dispatch = useAppDispatch();
  const reviews = useAppSelector(state => state.sellerReviews);
  const reviewsMeta = useAppSelector(state => state.sellerReviews.meta?.[singleSellerReviewsEndpoint(username)]);
  const pagesCount = reviewsMeta?.meta.pagination?.pages;
  const pinnedReview = useAppSelector(selectPinnedSellerReview);

  useEffect(() => {
    if (reviewsMeta) { return; }
    dispatch(getSellerReviews({
      username,
      page: DEFAULT_STARTING_PAGE_NUMBER
    }));
    dispatch(getSellerReviews({
      username,
      page: DEFAULT_STARTING_PAGE_NUMBER,
      isPinned: true
    }));
  }, []);

  const handleChange = page => {
    dispatch(getSellerReviews({
      username,
      page
    }));
  };

  return (
  <div styleName="review">
    <ReviewSummary positive={reviewsMeta?.meta.positiveAmount} negative={reviewsMeta?.meta.negativeAmount} username={username} />

    {pinnedReview &&
      <ReviewCard review={pinnedReview} key={`review-card-pinned-${pinnedReview.id}`} username={username} pinned />
    }

    { reviewsMeta?.data?.map(reviewMeta => {
      const id = reviewMeta.id;

      if (pinnedReview && id === pinnedReview.id) {
        // tslint:disable-next-line:no-null-keyword
        return null;
      }

      const reviewItem = reviews.entities[id];

      return <ReviewCard review={reviewItem} key={`review-card-${reviewItem.id}`} username={username} />;
    })}

    { pagesCount > 1 &&
      <div styleName="review-pagination">
        <NumberedPagination
          breakLabel="..."
          nextLabel={<span className="dashicon dashicon-chevron-right"/>}
          previousLabel={<span className="dashicon dashicon-chevron-left"/>}
          onPageChange={
            event => {
              handleChange(event.selected + 1);
              setTimeout(() => document.getElementById('reviews')
                .scrollIntoView({ behavior: 'smooth' }), 100);
            }
          }
          pageCount={pagesCount}
        />
      </div>
    }
  </div>
  );
};
